import { render, staticRenderFns } from "./Ahorros.vue?vue&type=template&id=cfe0f5a2&"
import script from "./Ahorros.vue?vue&type=script&lang=js&"
export * from "./Ahorros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports